export class SsrsViewerCommandModel {
  public Parameters: boolean;
  public StyleSheet: string;
}



// WEBPACK FOOTER //
// ./src/app/report/models/SsrsViewerCommandModel.ts